//main.js
console.log("main.js loaded");
document.addEventListener('DOMContentLoaded', function () {
    const accordionTrigger = document.querySelector('[data-accordion-trigger="accordion-cart-notes"]');
    const accordionBody = document.getElementById('accordion-cart-notes');
  
    if (accordionTrigger && accordionBody) {
      accordionTrigger.addEventListener('click', function () {
        const isExpanded = accordionTrigger.getAttribute('aria-expanded') === 'true';
  
        accordionTrigger.setAttribute('aria-expanded', !isExpanded);
        accordionBody.style.display = isExpanded ? 'none' : 'block';
      });
  
      accordionTrigger.setAttribute('aria-expanded', 'false'); 
      accordionBody.style.display = 'none';
    }
  });
  $(document).ready(function(){
            $('.team-carousel').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: $('.team-section .prev-btn'),
                nextArrow: $('.team-section .next-btn'),
                dots: false,
                autoplay: false,
                autoplaySpeed: 5000,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            arrows: false,
                            dots: true
                        }
                    }
                ]
            });
            
            // Add animation to team members on hover
            $('.team-member').hover(
                function() {
                    $(this).css('transform', 'translateY(-10px)');
                },
                function() {
                    $(this).css('transform', 'translateY(0)');
                }
            );
            
            // Animation observer
            const observerOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 0.1
            };
            
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate');
                    }
                });
            }, observerOptions);
            
            document.querySelectorAll('.animate').forEach(el => {
                observer.observe(el);
            });
        });

document.addEventListener('DOMContentLoaded', function() {
  // Initialize Slick Carousel
  $('.events-carousel').slick({
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 3,
    focusOnSelect: true,
    arrows: true,
    prevArrow: "<button type='button' class='slick-prev'><svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'><rect x='0.5' y='0.5' width='47' height='47' rx='4.5' stroke='#C6AD93'/><path d='M32 23H19.83L25.42 17.41L24 16L16 24L24 32L25.41 30.59L19.83 25H32V23Z' fill='#000'/></svg></button>",
    nextArrow: "<button type='button' class='slick-next'><svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'><rect x='0.5' y='0.5' width='47' height='47' rx='4.5' stroke='#C6AD93'/><path d='M24 16L22.59 17.41L28.17 23H16V25H28.17L22.59 30.59L24 32L32 24L24 16Z' fill='#000'/></svg></button>",
    dots: false,
    infinite: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 6000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerMode: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: false
        }
      }
    ]
  });

  // // Filter functionality
  // const filterButtons = document.querySelectorAll('.story-filters button');
  // const storyCards = document.querySelectorAll('.story-card');

  // filterButtons.forEach(button => {
  //   button.addEventListener('click', () => {
  //     const filter = button.dataset.filter;

  //     // Update active button
  //     filterButtons.forEach(btn => btn.classList.remove('active'));
  //     button.classList.add('active');

  //     // Filter cards
  //     storyCards.forEach(card => {
  //       const tags = card.dataset.tags ? card.dataset.tags.split(',') : [];

  //       if (filter === 'all' || tags.includes(filter)) {
  //         card.style.display = 'block';
  //       } else {
  //         card.style.display = 'none';
  //       }
  //     });
  //   });
  // });

  // Video popup
  $('.video-popup').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 300,
    preloader: true,
    fixedContentPos: true,
    iframe: {
      patterns: {
        youtube: {
          index: 'youtube.com/',
          id: function(url) {
            var match = url.match(/[?&]v=([^&]+)/);
            return match && match[1] ? match[1] : null;
          },
          src: 'https://www.youtube.com/embed/%id%?rel=0&modestbranding=1'
        }
      }
    }
  });

  
  // Modal functionality
  const modal = document.getElementById('story-upload-modal');
  const openBtn = document.getElementById('open-upload-modal');
  const closeBtn = document.querySelector('.close');
  
  if (openBtn) {
    openBtn.addEventListener('click', () => {
      modal.style.display = 'block';
      document.body.style.overflow = 'hidden';
    });
  }
  
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    });
  }
  
  window.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  });
  

});